import { ENTITIES } from '@/api/api.constant';
import { UserLg, UserXs } from '@/types/user-cabinet';
import { apiBaseUrl } from '@/utils/constants';

const fields$name = 'first_name' satisfies keyof UserXs;
export const get$user$name = async (token: string): Promise<Pick<UserXs, 'first_name'>> => {
    const response = await fetch(`/api/users/me?fields=${fields$name}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    }).then((res) => res.json());
    return response?.data || null;
};

const fields$details = [
    'email',
    'first_name',
    'last_name',
    'telegram',
    'instagram',
    'phone',
    'address',
    'company',
] satisfies Array<keyof UserLg>;

export async function get$user$details(token: string): Promise<UserLg> {
    const response = await fetch(`${apiBaseUrl}/users/me?fields=${fields$details}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    }).then((res) => res.json());
    return response?.data || null;
}

export const patchUser = async (data: {
    data: Omit<UserXs, 'address' | 'company'>;
    token: string;
}): Promise<UserXs> => {
    const response = await fetch(`/api/users/me`, {
        method: 'PATCH',
        headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${data.token}`,
        },
        body: JSON.stringify(data.data),
    }).then((res) => res.json());
    return response?.data || null;
};

export const updatePassword = async (userData: { password: string; token: string }): Promise<UserXs> => {
    const response = await fetch(`/api/users/me`, {
        method: 'PATCH',
        headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${userData.token}`,
        },
        body: JSON.stringify({ password: userData.password }),
    }).then((res) => res.json());
    return response?.data || null;
};

export const getUserById = async (id: string) => {
    const filter = {
        id: {
            _eq: id,
        },
    };
    const filterString = encodeURIComponent(JSON.stringify(filter));
    const url = `${apiBaseUrl}${ENTITIES.users}?fields=${fields$details}&filter=${filterString}`;
    const response = await fetch(url).then((res) => res.json());
    return response.data ?? [];
};
